import React, { useEffect, useRef, useState } from 'react';
export function VisibilityDetector({ onVisible, onHidden, onFirstVisible, style, children, }) {
    const ref = useRef(null);
    const [wasVisible, setWasVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.intersectionRatio > 0) {
                if (!wasVisible) {
                    setWasVisible(true);
                    onFirstVisible?.();
                }
                onVisible?.();
            }
            else {
                onHidden?.();
            }
        }, {
            root: null,
            rootMargin: '0px',
            threshold: [0.0],
        });
        if (ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [onFirstVisible, onVisible, onHidden, wasVisible]);
    return (React.createElement("div", { style: style, ref: ref }, children));
}
//# sourceMappingURL=visibility-detector.js.map